<template>
    <div>
      <div><b>Selected Options</b></div>
      <ul class="options list-unstyled">
        <li v-for="option in standardOptions">
          <span class="name">
            {{ option.description }}
          </span>
        </li>
      </ul>

<!--      <template v-if="additionalOptions.length">
        <div><b>Additional Options</b></div>
        <ul class="options list-unstyled">
          <li v-for="option in additionalOptions">
            <span class="name">
              {{ option.description }}
            </span>
          </li>
        </ul>
      </template>-->
    </div>
</template>

<script>
import VehicleImage from "../vehicle-details/vehicle-image.vue";
import ComparisonAdditional from "../car-comparison/comparison-additional.vue";

export default {
  name: "vehicle-specs",

  components: {VehicleImage, ComparisonAdditional},

  props: ["quote", 'adminPortalData'],

  computed: {
    standardOptions() {
      const options = [];
      this.quote.details.factoryOptions.forEach(option => {
        if (!option.isDefault) {
          options.push(option);
        }
      });
      return options;
    },

    additionalOptions() {
      const options = [];
      this.quote.details.factoryOptions.forEach(option => {
        if (option.isDefault) {
          options.push(option);
        }
      });
      return options;
    },
  }
};
</script>

<style scoped lang="scss">
ul.options {
  li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 12px;
  }
}
</style>
